export default __webpack_public_path__ + "static/media/bemovil.c713624c.svg";